'use client';


import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * @file theme-provider.jsx
 * @description Theme provide to preserve the user theme choose.
 * @version 0.0.1
 * Created at: 12/08/2025
 * Updated at: 12/08/2025
 */
export const ThemeProvider = ({ children, ...props }) => {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
};
